const Counter = {
  init(target) {
    const plus = target.querySelector('.button__counter--add')
    const minus = target.querySelector('.button__counter--minus')
    const input = target.querySelector('input')

    plus.addEventListener('click', (e) => this.onAdd(e, input))
    minus.addEventListener('click', (e) => this.onMinus(e, input))
    target.addEventListener('click', this.onCounterClick)
    input.addEventListener('change', (e) => this.onInputChange(e, input))
    input.addEventListener('keyup', (e) => this.onInputChange(e, input))
  },

  onInputChange(e, input: HTMLInputElement) {
    const inputLength = e.target.value.length
    if (inputLength > 2) {
      input.style.width = `${inputLength * 1.1}ch`
    }
  },

  onCounterClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()
  },

  onAdd(e: Event, input: HTMLInputElement) {
    e.preventDefault()
    const currentVal = parseInt(input.value, 10)
    // @ts-ignore
    input.value = currentVal + 1
  },

  onMinus(e: Event, input: HTMLInputElement) {
    e.preventDefault()
    const currentVal = parseInt(input.value, 10)
    if (currentVal > 1) {
      // @ts-ignore
      input.value = currentVal - 1
    }
  },
}
export default Counter
